import { useInfiniteQuery } from '@tanstack/react-query'

import { useCoords } from '~map-search/hooks/useCoords'
import { useKeywords } from '~map-search/hooks/useKeywords'
import { useSort } from '~map-search/hooks/useSort'
import { useTagIds } from '~map-search/hooks/useTagIds'

import { searchMaps } from '~map-search/api/searchMaps'

import { Feed_Types } from '~map-search/types/__generated/gql/graphql'

export const getSearchMapsKey = (key) => ['searchMaps', key]

export function useInfiniteSearchMaps(
  initialNumToRender: number,
  itemsPerRow: number
): any {
  const coords = useCoords()
  const feedType = useSort()
  const tagIds = useTagIds()
  const keywords = useKeywords()

  const key = {
    feedType,
    tagIds,
    query: keywords,
    ...(feedType === Feed_Types.Near && {
      coords
    })
  }

  const query = useInfiniteQuery({
    maxPages: undefined,
    queryKey: getSearchMapsKey(key),
    queryFn: async (context) => {
      const params = { ...context.pageParam }

      const variables = {
        ...params,
        ...key
      }

      const data = await searchMaps(variables)
      return data
    },
    initialPageParam: {
      from: 0,
      size: initialNumToRender
    },
    getNextPageParam: (lastPage, allPages) => {
      const all = allPages.flatMap((page) => page?.searchMaps.items || [])

      const hasNextPage = lastPage?.searchMaps.total - all.length > 0

      if (!hasNextPage) return undefined

      return {
        from: all?.length,
        size: itemsPerRow
      }
    }
  })

  const id = [
    key.feedType,
    ...key.tagIds,
    key.query,
    key.coords?.lat,
    key.coords?.lng
  ]
    .filter(Boolean)
    .join(':')

  return { ...query, id }
}
